module.exports = __webpack_public_path__ + "img/dayu_logo_mini.11dca53c.png";